/**
 * TimeOff Form Reducer
 * Manages form state using useReducer pattern
 */

// Action Types
export const FORM_ACTION_TYPES = {
  // Field Updates
  SET_USER_ID: "SET_USER_ID",
  SET_TYPE_OF_LEAVE: "SET_TYPE_OF_LEAVE",
  SET_START_TIME: "SET_START_TIME",
  SET_END_TIME: "SET_END_TIME",
  SET_UPLOAD_DOCUMENT: "SET_UPLOAD_DOCUMENT",
  SET_NOTE: "SET_NOTE",
  SET_DATE_RANGE: "SET_DATE_RANGE",
  SET_DATE_RANGE_TYPE: "SET_DATE_RANGE_TYPE",
  
  // Validation
  SET_LEAVE_TYPE_VALID: "SET_LEAVE_TYPE_VALID",
  SET_USER_VALID: "SET_USER_VALID",
  SET_DATE_RANGE_VALID: "SET_DATE_RANGE_VALID",
  SET_START_TIME_VALID: "SET_START_TIME_VALID",
  SET_END_TIME_VALID: "SET_END_TIME_VALID",
  SET_NOTE_VALID: "SET_NOTE_VALID",
  SET_DOCUMENT_VALID: "SET_DOCUMENT_VALID",
  
  // Reset
  RESET_FORM: "RESET_FORM",
  RESET_VALIDATION: "RESET_VALIDATION",
  
  // Bulk Update
  SET_FORM_DATA: "SET_FORM_DATA",
  SET_VALIDATION_STATE: "SET_VALIDATION_STATE",
};

// Initial Form State
export const initialFormState = {
  // Form Fields
  userId: "",
  typeOfLeave: "",
  startTime: "",
  endTime: "",
  uploadDocument: null,
  uploadDocumentName: null,
  note: "",
  dateRange: {
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  },
  dateRangeType: "",
  
  // Validation States
  leaveTypeIsValid: false,
  userIsValid: false,
  dateRangeIsValid: false,
  startTimeIsValid: false,
  endTimeIsValid: false,
  noteIsValid: false,
  documentIsValid: false,
};

/**
 * Form Reducer
 * @param {Object} state - Current form state
 * @param {Object} action - Action object with type and payload
 * @returns {Object} New form state
 */
export const timeOffFormReducer = (state, action) => {
  switch (action.type) {
    // Field Updates
    case FORM_ACTION_TYPES.SET_USER_ID:
      return {
        ...state,
        userId: action.payload,
        userIsValid: false, // Reset validation when field changes
      };
    
    case FORM_ACTION_TYPES.SET_TYPE_OF_LEAVE:
      return {
        ...state,
        typeOfLeave: action.payload,
        leaveTypeIsValid: false,
      };
    
    case FORM_ACTION_TYPES.SET_START_TIME:
      return {
        ...state,
        startTime: action.payload,
        startTimeIsValid: false,
      };
    
    case FORM_ACTION_TYPES.SET_END_TIME:
      return {
        ...state,
        endTime: action.payload,
        endTimeIsValid: false,
      };
    
    case FORM_ACTION_TYPES.SET_UPLOAD_DOCUMENT:
      return {
        ...state,
        uploadDocument: action.payload.file,
        uploadDocumentName: action.payload.name || null,
        documentIsValid: false,
      };
    
    case FORM_ACTION_TYPES.SET_NOTE:
      return {
        ...state,
        note: action.payload,
        noteIsValid: false,
      };
    
    case FORM_ACTION_TYPES.SET_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
        dateRangeIsValid: false,
      };
    
    case FORM_ACTION_TYPES.SET_DATE_RANGE_TYPE:
      return {
        ...state,
        dateRangeType: action.payload,
      };
    
    // Validation Updates
    case FORM_ACTION_TYPES.SET_LEAVE_TYPE_VALID:
      return {
        ...state,
        leaveTypeIsValid: action.payload,
      };
    
    case FORM_ACTION_TYPES.SET_USER_VALID:
      return {
        ...state,
        userIsValid: action.payload,
      };
    
    case FORM_ACTION_TYPES.SET_DATE_RANGE_VALID:
      return {
        ...state,
        dateRangeIsValid: action.payload,
      };
    
    case FORM_ACTION_TYPES.SET_START_TIME_VALID:
      return {
        ...state,
        startTimeIsValid: action.payload,
      };
    
    case FORM_ACTION_TYPES.SET_END_TIME_VALID:
      return {
        ...state,
        endTimeIsValid: action.payload,
      };
    
    case FORM_ACTION_TYPES.SET_NOTE_VALID:
      return {
        ...state,
        noteIsValid: action.payload,
      };
    
    case FORM_ACTION_TYPES.SET_DOCUMENT_VALID:
      return {
        ...state,
        documentIsValid: action.payload,
      };
    
    // Bulk Updates
    case FORM_ACTION_TYPES.SET_FORM_DATA:
      return {
        ...state,
        ...action.payload,
      };
    
    case FORM_ACTION_TYPES.SET_VALIDATION_STATE:
      return {
        ...state,
        ...action.payload,
      };
    
    // Reset Actions
    case FORM_ACTION_TYPES.RESET_FORM:
      return {
        ...initialFormState,
        dateRange: {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      };
    
    case FORM_ACTION_TYPES.RESET_VALIDATION:
      return {
        ...state,
        leaveTypeIsValid: false,
        userIsValid: false,
        dateRangeIsValid: false,
        startTimeIsValid: false,
        endTimeIsValid: false,
        noteIsValid: false,
        documentIsValid: false,
      };
    
    default:
      return state;
  }
};
